export const FeatureFlags = {
  RemoveMspDelayedBilling: 'remove-msp-delayed-billing',
};
